/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M10 9.576v12.848c0 .433.483.71.885.51l12.792-6.403c.43-.215.43-.8.002-1.017L10.886 9.068c-.402-.203-.886.074-.886.508z" _fill="#0B2C62"/>'
  }
})
